import { FC, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/rootReducer';
import Button from '../../Button';
import { Select } from 'antd';
import SelectCampus from '../../SelectCampus';
import { useHistory, useLocation } from 'react-router-dom';
import QueryString from 'qs';
import { useTranslation } from 'react-i18next';
import SelectEduStep from '../../SelectEduStep';
import { qsParse } from '../../../lib/util';
import { fi } from 'date-fns/locale';

const StudentSearch: FC = () => {
  const { t, i18n } = useTranslation();
  const history = useHistory();
  const { commonCodes } = useSelector((state: RootState) => state.commonCode);
  const { currentCampus } = useSelector((state: RootState) => state.auth);
  // MB0003 = 학생 상태
  const MB0003 = commonCodes.find((item: any) => item.commonCode === 'MB0003')?.detailCode;

  const [statusCode, setStatusCode] = useState('');
  const [eduStepCode, setEduStepCode] = useState('');
  const [field, setField] = useState('studentName');
  const [keyword, setKeyword] = useState('');
  const location = useLocation();
  const query = qsParse(location.search);

  type PreprocessFunction = (value: string) => string;

  const preprocessMap: Record<string, PreprocessFunction> = {
    studentPhoneNumber: (value) => value.replaceAll('-', ''),
  };

  const preprocessKeyword = (field: string, keyword: string): string => {
    const resultKeyword = preprocessMap[field]?.(keyword) ?? keyword;
    return resultKeyword?.trim();
  };


  const onSearch = () => {
    const params: any = { page: 1 };

    if (currentCampus) {
      params.campusCode = currentCampus;
    }

    if (statusCode) {
      params.statusCode = statusCode;
    }
    if (eduStepCode) {
      params.eduStepCode = eduStepCode;
    }
    if (field && keyword) {
      params.field = field;
      params.keyword = preprocessKeyword(field, keyword);
    }

    history.push(`/student/student?${QueryString.stringify(params)}`);
  };

  useEffect(() => {
    if (query.keyword && query.field) {
      setField(query.field as string);
      setKeyword(query.keyword as string);
    }
  }, [location])

  return (
    <>
    <div className="common-search">
      <div className="search-area">
        <ul className="search-bx">
          <li>
            <label>{t('common.menu.campus')}</label>
            <div>
              <SelectCampus />
            </div>
          </li>
          <li>
            <label>{t('student.student.column4')}</label>
            <Select
              placeholder={t('student.student.column4')}
              value={statusCode}
              onChange={value => {
                setStatusCode(value);
                setEduStepCode('');
              }}
            >
              <Select.Option value="">{t('student.student.option1')}</Select.Option>
              {MB0003?.map((item: any) => {
                return (
                  <Select.Option
                    key={item.detailCode}
                    value={item.detailCode}
                  >
                    {i18n.language === 'ko' ? item.korName : item.engName}
                  </Select.Option>
                );
              })}
            </Select>
          </li>
          <li>
            <label>{t('common.placeholder.1')}</label>
            <div>
              <SelectEduStep
                eduStepCode={eduStepCode}
                setEduStepCode={setEduStepCode}
                includeAll
                fullWidth
                disabled={statusCode === 'NR'}
              />
            </div>
          </li>
          <li>
            <div>
              <Select
                placeholder={t('student.student.placeholder6')}
                value={field}
                onChange={value => setField(value)}
              >
                <Select.Option value="studentName">{t('student.student.placeholder2')}</Select.Option>
                <Select.Option value="studentWebId">{t('student.student.option31')}</Select.Option>
                <Select.Option value="memberCode">{t('student.student.option34')}</Select.Option>
                <Select.Option value="studentPhoneNumber">{t('학생 전화번호')}</Select.Option>
                <Select.Option value="parentName">{t('student.student.option32')}</Select.Option>
                <Select.Option value="parentPhoneNumber">{t('student.student.option33')}</Select.Option>
              </Select>
            </div>
            <input
              type="text"
              className="form-control"
              placeholder={t('student.student.placeholder7')}
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              onKeyPress={(e) => {
                if (e.key === 'Enter') onSearch();
              }}
            />
            <div className="comm-btn__area">
              <Button
              className="btn-basic small black"
              onClick={() => onSearch()}
              text={t('common.button.search')}
              />
            </div>
          </li>
        </ul>
      </div>
    </div>
    </>
  );
};

export default StudentSearch;
